export default __webpack_public_path__ + "static/media/two.d91ee081.svg";